import GeoLocationButton from './GeoLocationButton';
import SaveSearch from './SaveSearch';
import {
  Bar,
  SearchToolsContainer,
  SortSaveSearch
} from './SearchHeader.styles';
import SortButton from './SortButton';

export default function SearchTools() {
  return (
    <SearchToolsContainer id="search-tools">
      <GeoLocationButton />
      <SortSaveSearch>
        <SortButton />
        <Bar />
        <SaveSearch />
      </SortSaveSearch>
    </SearchToolsContainer>
  );
}
